import React from "react";
import { Campaign } from "../../services";
import { authService } from "../../services/auth";

interface CampaignStatusToggleProps {
  campaign: Campaign;
  onToggle: (id: string) => void;
}

const CampaignStatusToggle: React.FC<CampaignStatusToggleProps> = ({
  campaign,
  onToggle,
}) => {
  console.log("CampaignStatusToggle render - campaign:", campaign);
  console.log("CampaignStatusToggle render - status:", campaign.status);
  console.log(
    "Status interpretation:",
    campaign.status === 1 ? "BẬT (1)" : "TẮT (2)"
  );

  const now = new Date();
  const endDate = new Date(campaign.end_date);

  // So sánh chỉ theo ngày, không theo giờ
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const endDay = new Date(
    endDate.getFullYear(),
    endDate.getMonth(),
    endDate.getDate()
  );
  const isExpired = endDay < today;
  const isAdmin = authService.isAdmin();

  // Determine actual status: if expired, show "Đã kết thúc" regardless of campaign.status
  const getActualStatus = () => {
    if (isExpired) {
      return { text: "Đã kết thúc", color: "text-red-500" };
    }
    if (campaign.status === 1) {
      return { text: "Đang hoạt động", color: "text-green-600" };
    }
    if (campaign.status === 2) {
      return { text: "Đã tắt", color: "text-gray-500" };
    }
    return { text: "Không xác định", color: "text-yellow-500" };
  };

  const actualStatus = getActualStatus();

  // If not admin, show only text status
  if (!isAdmin) {
    return (
      <span className={`text-sm font-medium ${actualStatus.color}`}>
        {actualStatus.text}
      </span>
    );
  }

  // Admin can toggle status - cho phép chỉnh sửa ngay cả khi đã kết thúc
  return (
    <button
      onClick={() => onToggle(campaign._id!)}
      disabled={false}
      className={`relative inline-flex h-5 w-10 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 ${
        campaign.status === 1 ? "bg-green-500" : "bg-gray-200"
      } cursor-pointer`}
      title={campaign.status === 1 ? "Tắt chiến dịch" : "Bật chiến dịch"}
    >
      <span
        className={`inline-block h-3 w-3 transform rounded-full bg-white transition-transform ${
          campaign.status === 1 ? "translate-x-6" : "translate-x-1"
        }`}
      />
    </button>
  );
};

export default CampaignStatusToggle;
